export var setWildcardLocaleCookie = function (_a) {
    var locale = _a.locale, domain = _a.domain;
    document.cookie = "external-locale=" + locale + "; domain=" + domain + "; path=/; secure; expires=Tue, 19 Jan 2038 03:14:07 GMT";
};
